<template>
  <div>
    <div>
      <Row class="expand-row">
        <Col span="12">
          <span class="expand-key">{{ $t("RAM.AWS.eks.endpoint") }}</span>
          <span class="expand-value">{{ row.endpoint }}</span>
        </Col>
        <Col span="12">
          <span class="expand-key">IAM Role: </span>
          <span class="expand-value">{{ row.roleArn }}</span>
        </Col>
      </Row>
      <Row class="expand-row">
        <Col span="12">
          <span class="expand-key">VPC ID: </span>
          <span class="expand-value">{{ row.vpcId }}</span>
        </Col>
      </Row>
      <Row class="expand-row">
        <Table
          :no-data-text="$t('common.noData')"
          :columns="columns"
          :data="securityData"
          style="width: 100%"
        ></Table>
      </Row>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    row: Object,
  },
  data() {
    return {
      columns: [
        {
          title: this.$t("RAM.AWS.eks.pointName"),
          key: "name",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline",
                },
                /*   on: {
                                click: () => {
                                    this.$router.push({path: '/resourceConfigurationManagement/aws/subnetResource', query:{subnetIds:params.row.subnetId,type:"subnetId",t:Date.now()}})
                                }
                            } */
              },
              params.row.name
            );
          },
        },
        {
          title: this.$t("RAM.AWS.eks.releaseVersion"),
          key: "releaseVersion",
        },
        {
          title: this.$t("RAM.AWS.eks.status"),
          key: "status",
        },
        {
          title: this.$t("RAM.AWS.eks.minSize"),
          key: "minSize",
        },
        {
          title: this.$t("RAM.AWS.eks.maxSize"),
          key: "maxSize",
        },
        {
          title: this.$t("RAM.AWS.eks.amiType"),
          key: "amiType",
        },
        {
          title: this.$t("RAM.AWS.eks.diskSize"),
          key: "diskSize",
        },
      ],
      securityData: this.row.resourceEksNodeGroupDTOS,
    };
  },
};
</script>
<style scoped>
.expand-row {
  padding-left: 17px;
  margin-bottom: 10px;
}
.expand-key {
  width: 145px;
  display: block;
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/eks/TableExpand.vue